import type {State} from 'src/reducers';
import type {ToastMessage} from 'src/types/toast';


export const getToasts = (state: State): ToastMessage[] => state.toasts;
